import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
// import "./index.css";

import { Provider } from "react-redux";
import store from "./store";
import { BrowserRouter as Router } from 'react-router-dom';

import * as yup from "yup";

window.social_media = {}
// Twitter: Solyd Floors (@SolydFloors) / Twitter
window.social_media.twitter = "https://twitter.com/SolydFloors"
// YouTube: Solyd Floors - YouTube
// LinkedIn: https://www.linkedin.com/company/solyd-floors
window.social_media.linkedin = "https://www.linkedin.com/company/solyd-floors"
// Facebook: Solyd Floors | Facebook
window.social_media.facebook = "https://www.facebook.com/solydfloors"
// Pinterest: www.pinterest.com/SolydFloors
window.social_media.pinterest = "https://www.pinterest.com/SolydFloors/"
// Instagram: Solyd Floors (@solydfloors) • Instagram photos and videos
window.social_media.instagram = "https://www.instagram.com/solydfloors/"
// Google Business: https://g.page/solydfloors?gm  (@solydfloors)
window.social_media.google_business = "https://g.page/solydfloors?gm"


function equalTo(ref, msg) {
	return this.test({
		name: 'equalTo',
		exclusive: false,
    message: msg || '${path} must be the same as ${reference}',
		params: {
			reference: ref.path
		},
		test: function(value) {
      return value === this.resolve(ref) 
		}
	})
};

yup.addMethod(yup.string, 'equalTo', equalTo);

global.string_to_qs = params => Object.keys(params)
  .map(key => `${key}=${params[key]}`)
  .join('&');

function float2int (value) {
    console.log({a:value , b: value | 0})
    return value | 0;
}

global.get_token = () => {
  let token = localStorage.getItem("solyd_floors:token");
  let guest_token = localStorage.getItem("solyd_floors:guest_token");
  return token || guest_token;
}
global.sqft_to_boxes = sqft => {
  let val = Number(sqft)
  console.log({vallllll: val})
  // let ten_percent = val * 0.1
  // val += ten_percent
  val /= 23.4
  if (float2int(val) === val) return { val };
  else val = float2int(val) + 1
  return { val, more: true };
}

global.prettifyPrice = price => {
  let splitted = String(price).split(".")
  if (!(splitted.length > 1)) return price;
  let [ val, val2 ] = splitted
  if (String(val2).length == 1) val2 += 0; 
  return val + '.' + val2.slice(0,2)
}

global.getStars = (rating) => {
  let bold_star_src = "../../assets/toolkit/images/bold-star.svg"
  let star_src = "../../assets/toolkit/images/star.svg"
  console.log({rating})
  return (
      <React.Fragment>
          <img 
              src={rating > 1 ? bold_star_src : star_src} 
              alt="" 
          />
          <img 
              src={rating > 3 ? bold_star_src : star_src} 
              alt="" 
          />
          <img 
              src={rating > 5 ? bold_star_src : star_src} 
              alt="" 
          />
          <img 
              src={rating > 7 ? bold_star_src : star_src} 
              alt="" 
          />
          <img 
              src={rating > 9 ? bold_star_src : star_src} 
              alt="" 
          />
      </React.Fragment>
  )
}

global.timeSince = (date) => {
  if (typeof(date) === "string") date = new Date(date);
  var seconds = Math.floor((new Date() - date) / 1000);

  var interval = seconds / 31536000;

  if (interval > 1) {
    return Math.floor(interval) + ` year${Math.floor(interval) == 1 ? "" :"s"}`;
  }
  interval = seconds / 2592000;
  if (interval > 1) {
    return Math.floor(interval) + ` month${Math.floor(interval) == 1 ? "" :"s"}`;
  }
  interval = seconds / 86400;
  if (interval > 1) {
    return Math.floor(interval) + ` day${Math.floor(interval) == 1 ? "" :"s"}`;
  }
  interval = seconds / 3600;
  if (interval > 1) {
    return Math.floor(interval) + ` hour${Math.floor(interval) == 1 ? "" :"s"}`;
  }
  interval = seconds / 60;
  if (interval > 1) {
    return Math.floor(interval) + ` minute${Math.floor(interval) == 1 ? "" :"s"}`;
  }
  return Math.floor(seconds) + ` second${Math.floor(interval) == 1 ? "" :"s"}`;
}

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <Router>
        <App />
      </Router>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
